import React from 'react';
import { AccountPosition } from '../types';

interface PositionHeaderProps {
  position: AccountPosition;
  getPositionTypeIcon: (positionType: string) => React.ReactNode;
  getRankIcon: (rank: number) => React.ReactNode;
  getRankColor: (rank: number) => string;
  getStatusColor: (status: string) => string;
  getPriorityColor: (priority: string) => string;
  isExpired: (expiresAt: string) => boolean;
}

const PositionHeader: React.FC<PositionHeaderProps> = ({
  position,
  getPositionTypeIcon,
  getRankIcon,
  getRankColor,
  getStatusColor,
  getPriorityColor,
  isExpired,
}) => {
  return (
    <div className="flex items-center space-x-3 mb-3">
      <div className="flex items-center space-x-2">
        {getPositionTypeIcon(position.actualPosition?.positionType || 'EQUITY')}
        <span className="text-xl font-bold text-gray-900">
          {position.symbol}
        </span>
      </div>

      {/* Ranking Information */}
      {position.rank && position.totalRecommendations && (
        <div className="flex items-center space-x-2">
          {getRankIcon(position.rank)}
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${getRankColor(position.rank)}`}
          >
            Rank {position.rank} of {position.totalRecommendations}
          </span>
        </div>
      )}

      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(position.status)}`}
      >
        {position.status}
      </span>

      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(position.priority)}`}
      >
        {position.priority}
      </span>

      {isExpired(position.expiresAt || '') && (
        <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
          EXPIRED
        </span>
      )}
    </div>
  );
};

export default PositionHeader;
